import "./OverlayLoading.scss";

import * as React from "react";
import InlineLoading from "./InlineLoading";
import { LoadingOverlay, type LoaderProps } from "@mantine/core";

interface IOverlayLoadingProps {
    size?: LoaderProps["size"];
    text?: string;
    onWhite?: boolean;
}

class OverlayLoading extends React.Component<IOverlayLoadingProps, any> {
    render() {
        const { size = "lg", text, onWhite } = this.props;

        return (
            <LoadingOverlay
                visible={true}
                zIndex={1000}
                overlayProps={{
                    color: onWhite ? "dark" : undefined,
                }}
                loaderProps={{
                    children: <InlineLoading size={size} text={text} />,
                }}
            />
        );
    }
}
export default OverlayLoading;
